import { eCoverageType } from 'ui-toolkit/enums/eCoverageType';

export interface IPremiumDetails {
  description: string;
  buyer?: number;
  seller?: number;
  other?: number;
  total?: number;
}

export interface IPolicyPremiumDetailsData {
  disclosed: IPremiumDetails[];
  actual: IPremiumDetails[];
  defaultOwnerSellerPaidPercent: number;
  ownerSellerPaidPercent: number;
  lenderSellerPaidPercent: number;
  cashPurchase: boolean;
  manuallyEdited: boolean;
  notes?: string;
  enabled?: boolean;
  ownerFormType?: eCoverageType;
  lenderFormType?: eCoverageType;
  availableOwnerForms: eCoverageType[];
  availableLenderForms: eCoverageType[];
  holdOpen?: boolean;
  holdOpenAvailable: boolean;
}

export const defaultPolicyPremiumDetailsData: IPolicyPremiumDetailsData = {
  disclosed: [],
  actual: [],
  defaultOwnerSellerPaidPercent: 0,
  ownerSellerPaidPercent: 0,
  lenderSellerPaidPercent: 0,
  cashPurchase: false,
  manuallyEdited: false,
  availableOwnerForms: [],
  availableLenderForms: [],
  enabled: true,
  holdOpen: false,
  holdOpenAvailable: false,
};

export const createMockPolicyPremiumDetailsData = (
  overrides?: Partial<IPolicyPremiumDetailsData>
): IPolicyPremiumDetailsData => {
  return { ...defaultPolicyPremiumDetailsData, ...overrides };
};

export interface IUpdatePolicyPremiumDetailsRequest {
  ownerSellerPaidPercent?: number;
  lenderSellerPaidPercent?: number;
  ownerFormType?: eCoverageType;
  lenderFormType?: eCoverageType;
  holdOpen?: boolean;
}
